import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';

const TIER_ORDER = ['mac-agent', 'mac-manager', 'mac-director', 'mac-architect'] as const;
type MacTier = (typeof TIER_ORDER)[number];

export function useMacRole() {
  const identityApi = useApi(identityApiRef);

  const { value: identity } = useAsync(
    () => identityApi.getBackstageIdentity(),
    [identityApi],
  );

  // Normalize: strip "group:<namespace>/" prefix from all refs
  const refs = (identity?.ownershipEntityRefs ?? []).map(r =>
    r.replace(/^group:[^/]+\//, ''),
  );

  // Find highest tier
  let tierIndex = -1;
  for (const ref of refs) {
    const idx = TIER_ORDER.indexOf(ref as MacTier);
    if (idx > tierIndex) tierIndex = idx;
  }
  const tier: MacTier | null = tierIndex >= 0 ? TIER_ORDER[tierIndex] : null;

  // Extract sectors (e.g. "sector-finance")
  const sectors = refs
    .filter(r => r.startsWith('sector-'))
    .map(r => r.slice('sector-'.length));

  const isAtLeast = (requiredTier: MacTier): boolean => {
    if (tier === null) return false;
    return TIER_ORDER.indexOf(tier) >= TIER_ORDER.indexOf(requiredTier);
  };

  return { tier, sectors, isAtLeast };
}
